// extracted by mini-css-extract-plugin
export var anchor = "lpTextStyles-module--anchor--464dc";
export var container = "lpTextStyles-module--container--1533a";